<template>
  <div class="course-module">
    <div class="name clickable" @click="selected = !selected">
      <h-icon v-if="!selected">keyboard_arrow_right</h-icon>
      <h-icon v-else>keyboard_arrow_down</h-icon>
      {{courseModule.title}}
      <h-icon v-if="completed">check_circle</h-icon>
    </div>
    <div 
      v-for="lesson in courseModule.lessons" 
      :key="lesson.id"
      v-if="selected"
      class="lesson">
      <lesson :lesson="lesson" />
    </div>
  </div>
</template>

<script>
import lesson from "./lesson";

export default {
  components: { lesson },
  props: ["courseModule"],
  data() {
    return {
      selected: false
    };
  },
  computed: {
    completed() {
      return this.courseModule.lessons.filter(l => !l.completed).length == 0;
    }
  }
};
</script>

<style lang="less" scoped>
.section {
  margin-left: 15px;
  // border-left-width: 2px;
  // border-left-style: solid;
  padding-left: 10px;
  line-height: 25px;
}
.course-module {
  margin-left: 15px;

}
</style>
